module.exports = __webpack_public_path__ + "static/volcan-952a022ed14125a53beafd6acd5628d4.webp";